import React from 'react';

export interface DesignCheckboxProps {
  disabled?: boolean;
  defaultChecked?: boolean;
  checked: boolean;
  id: string;
  label: string;
  value: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}
const DesignCheckbox = ({
  disabled,
  defaultChecked,
  checked,
  id,
  label,
  value,
  onChange,
}: DesignCheckboxProps) => (
  <div className="flex w-full gap-2">
    <input
      className="
        disabled:border-steel-400 disabled:bg-steel-400 peer relative mt-1 h-4 w-4  shrink-0 appearance-none rounded-sm border-2 bg-muted-white
        checked:border-0
        focus:outline-none
        dark:border-white dark:bg-design-black
      "
      id={id}
      type="checkbox"
      defaultChecked={defaultChecked}
      disabled={disabled}
      value={value}
      checked={checked}
      onChange={onChange}
    />
    <svg
      className="pointer-events-none absolute mt-1 hidden h-4 w-4 outline-none peer-checked:block dark:stroke-white"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <polyline points="20 6 9 17 4 12" />
    </svg>
    <label htmlFor={id}>{label}</label>
  </div>
);

DesignCheckbox.defaultProps = {
  disabled: false,
  defaultChecked: false,
};

export default DesignCheckbox;
